import {
  Box,
  ButtonLink,
  Columns,
  Heading,
  Stack,
  Actions,
} from 'braid-design-system';

import { ModuleTheme } from 'src/types';
import PageSection from 'src/views/shared/PageSection/PageSection';
import TrackingLink from 'src/views/shared/TrackingLink/TrackingLink';

import * as styles from './ContentSplitThreeColumn.css';

export interface Props {
  id: string;
  theme?: ModuleTheme;
  title: string;
  children: any;
  buttonLinkEvent: string;
  buttonLinkHref: string;
  buttonLinkText: string;
}

const ContentSplitThreeColumn = ({
  id,
  theme = ModuleTheme.LIGHT,
  title,
  children,
  buttonLinkEvent,
  buttonLinkHref,
  buttonLinkText,
}: Props) => (
  <PageSection id={id} theme={theme}>
    <Box textAlign={'center'}>
      <Stack space="xlarge">
        <Box className={styles.headingContainer}>
          <Heading level="2">{title}</Heading>
        </Box>
        <Columns collapseBelow="tablet" space={['xlarge', 'none']}>
          {children}
        </Columns>
        <Box display={['block', 'flex']} justifyContent={'center'}>
          <Actions>
            <TrackingLink
              renderAs={ButtonLink}
              href={buttonLinkHref}
              data-analytics={buttonLinkEvent}
              data-analytics-origin={id}
              data-test={`${id}-cta`}
              variant={theme === ModuleTheme.LIGHT ? 'ghost' : 'solid'}
            >
              {buttonLinkText}
            </TrackingLink>
          </Actions>
        </Box>
      </Stack>
    </Box>
  </PageSection>
);

export default ContentSplitThreeColumn;
